import { StateCreator } from 'zustand';
import { ValidationSlice } from './validation.types';

export const createValidationSlice: StateCreator<
  ValidationSlice,
  [],
  [],
  ValidationSlice
> = () => ({
  isConfirmed: false,
});
